
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationNavigationService } from './notification-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationClickedSource = new Subject<any>();
  public notificationClicked$ = this.notificationClickedSource.asObservable();

  private notificationCounterSource = new Subject<number>();
  public notificationCounter$ = this.notificationCounterSource.asObservable();

  constructor(private navigationService: NotificationNavigationService) {}

  /**
   * Trigger notification click and handle navigation
   * @param payload The notification payload from Firebase or in-app
   */
  triggerNotificationClick(payload: any) {
    this.notificationClickedSource.next(payload);

    // Handle navigation automatically
    this.navigationService.handlePushNotificationClick(payload);
  }

  /**
   * Update notification counter
   * @param counter The new notification count
   */
  updateNotificationCounter(counter: any) {
    this.notificationCounterSource.next(counter);
  }

  /**
   * Handle in-app notification click
   * @param notification The notification object from the list
   */
  handleInAppNotificationClick(notification: any) {
    this.navigationService.processNotificationClick(notification);
  }
}